<template>
    <AppTutorials />
</template>

<script>
import AppTutorials from '@/components/tutorials/AppTutorials.vue'

export default {
    name: 'ViewTutorials',
    components: {
        AppTutorials
    }
}
</script>